export default {"src":"/_next/static/media/reporting-and-remediation.75148434.svg","height":312,"width":264,"blurWidth":0,"blurHeight":0};